/** Fournisseur d'identité proposé pour une adresse e-mail (POST /auth/sso/discover). */
export interface SsoProvider {
  provider_id: number;
  label: string;
}

/** En-tête porteur du code métier d'une erreur d'authentification (SSO_*, IMPERSONATION_*). */
export const PU_ERROR_CODE_HEADER = 'PU-Error-Code';

/** Code renvoyé par /auth/login_check quand le compte se connecte par son fournisseur. */
export const SSO_REQUIRED_CODE = 'SSO_REQUIRED';

/** Codes métier connus de la connexion déléguée, traduits sous SSO.ERROR.<code>. */
export const SSO_ERROR_CODES = [
  'SSO_INVALID_RESPONSE',
  'SSO_ACCESS_DENIED',
  'SSO_PROVISIONING_DISABLED',
  'SSO_DOMAIN_NOT_ALLOWED',
  'SSO_STATE_EXPIRED',
  'SSO_INSUFFICIENT_ACR',
  'SSO_PROVIDER_UNAVAILABLE',
  'SSO_RATE_LIMITED',
  // Propre au frontoffice : le fournisseur renvoie une erreur (annulation, refus) au lieu d'un code.
  'SSO_PROVIDER_REFUSED',
] as const;

export type SsoErrorCode = (typeof SSO_ERROR_CODES)[number];

/** Limite de tentatives atteinte (discover/start) : seule erreur de découverte affichée. */
export const SSO_RATE_LIMITED_CODE: SsoErrorCode = 'SSO_RATE_LIMITED';

/** Code affiché quand l'erreur est inconnue ou sans code (coupure réseau…). */
export const SSO_FALLBACK_ERROR_CODE: SsoErrorCode = 'SSO_INVALID_RESPONSE';
